import styled from "styled-components";
import { ReactComponent as DownTriangleBlue } from "../Images/down_triangle_blue.svg";
import { ReactComponent as UpTriangleRed } from "../Images/up_triangle_red.svg";
import "../Styles/component.css";
import "../Styles/global.css";
import "../Styles/lists.css";
import { cCode_to_nation } from "../Utils/numberUtils";

const MemberRankingTable = ({ rankings, page }) => {
  return (
    <MemberRankingBox page={page}>
      <div className="memberRanking-label">
        <p className="center">랭킹</p>
        <p className="center">추이</p>
        <p className="leftalign">닉네임</p>
        <p className="leftalign">걸음 수</p>
        <p className="leftalign">국가</p>
      </div>
      {rankings.length === 0 && (
        <div
          style={{
            marginTop: "114px",
            fontFamily: "notoSans-medium",
            fontSize: "14px",
            color: "#6d6d6d",
          }}
          className="medium-text center"
        >
          구성원 랭킹 내역이 없습니다.
        </div>
      )}
      {rankings.slice(0, 10).map((data) => (
        <MemberRankingComponent
          key={`${data.nickName}-${data.ranking}`}
          ranking={data.ranking}
          upDown={data.upDown}
          nickName={data.nickName}
          totalStep={data.totalStep}
          cCode={data.cCode}
          page={page}
        />
      ))}
    </MemberRankingBox>
  );
};

const MemberRankingComponent = ({
  ranking,
  upDown,
  nickName,
  totalStep,
  cCode,
  page,
}) => {
  let _upDown = upDown;
  if (upDown === 0) {
    _upDown = "-";
  } else if (upDown < 0) {
    _upDown = 0 - upDown;
  }

  let _nickName = nickName;
  if (nickName.length > 8) {
    _nickName = nickName.substr(0, 8);
    _nickName += "...";
  }
  return (
    <MemberRankingData page={page}>
      <p className="center">{ranking?.toLocaleString()}위</p>
      <p className="center">
        {upDown === 0 ? (
          ""
        ) : upDown > 0 ? (
          <UpTriangleRed />
        ) : (
          <DownTriangleBlue />
        )}
        &nbsp;{_upDown}
      </p>
      <div className="scrollName leftalign">
        <p style={{ whiteSpace: "nowrap" }}>{_nickName}</p>
      </div>
      <p className="leftalign">{totalStep?.toLocaleString()}걸음</p>
      <p className="leftalign">{cCode_to_nation(cCode)}</p>
    </MemberRankingData>
  );
};

const MemberRankingBox = styled.div`
  width: ${(props) => (props.page === "Members" ? "auto" : "630px")};
  height: ${(props) => (props.page === "Members" ? "auto" : "716px")};
  .memberRanking-label {
    display: grid;
    grid-template-columns: ${(props) =>
      props.page === "Members"
        ? "100px 80px 220px 200px 140px"
        : "100px 80px 170px 160px 120px"};
    height: 44px;
    background-color: #f5f5f5;
    font-family: "notoSans-medium";
    font-size: 14px;
    color: #6d6d6d;
  }
`;

const MemberRankingData = styled.div`
  display: grid;
  grid-template-columns: ${(props) =>
    props.page === "Members"
      ? "100px 80px 220px 200px 140px"
      : "100px 80px 170px 160px 120px"};
  width: ${(props) => (props.page === "Members" ? "740px" : "630px")};
  height: 56px;
  box-shadow: inset 0 -1px 0 0 #e4e4e4;
  font-family: "notoSans";
  font-size: 16px;
  color: #000000;
  &:hover {
    background-color: #f5f5f5;
    cursor: pointer;
  }
`;

export default MemberRankingTable;
